import type {
  LayeredConstructionApiCatalogItem,
  LayeredConstructionCatalogItem,
  LayeredConstructionTechnology,
} from "../model/types";
import type { LayeredConstructionVariant } from "../model/variants";

export const normalizeCatalogItem = (
  item: LayeredConstructionApiCatalogItem,
  variant: LayeredConstructionVariant
): LayeredConstructionCatalogItem => ({
  ...item,
  typeName: String(item[variant.catalogTypeNameKey as keyof LayeredConstructionApiCatalogItem] ?? ""),
});

export const normalizeTechnology = (
  technology: LayeredConstructionTechnology,
  variant: LayeredConstructionVariant
): LayeredConstructionTechnology => ({
  ...technology,
  typeDbId: technology[variant.typeDbIdKey as keyof LayeredConstructionTechnology] as number | undefined,
});
